<div class="dialog-container">
  <div mat-dialog-content>
    <label for="" class="form-label">{{data.label}}</label>
    <input type="text" [(ngModel)]="data.value" class="form-control" [placeholder]=data.placeholder />
  </div>
  <app-dialog-footer [dialogResult]="data" wrapperClass="setup-footer" />
</div>
